"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.invokeValidateCallback = invokeValidateCallback;
exports.setValidateCallback = setValidateCallback;
exports.validateCallback = void 0;
var _noop2 = _interopRequireDefault(require("lodash/noop"));
let validateCallback = _noop2.default;
/**
 * Usually people want to set a default behavior for UI feedback when validation
 * fails for a whole form, e.g. an alert/toast/slidedown
 * @param   {function}      callbackFunction
 * @returns {function|null}
 */
exports.validateCallback = validateCallback;
function setValidateCallback(callbackFunction) {
  if (callbackFunction === undefined || callbackFunction === null) {
    exports.validateCallback = validateCallback = _noop2.default;
    return validateCallback;
  }
  if (typeof callbackFunction !== 'function') {
    console.trace('Argument received by setValidateCallback is not a function');
    return validateCallback;
  }
  exports.validateCallback = validateCallback = callbackFunction;
  return validateCallback;
}
function invokeValidateCallback(shouldInvoke) {
  if (shouldInvoke && typeof validateCallback === 'function') {
    validateCallback();
  }
}